import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import React, { useCallback, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import Logo from '../components/common/Logo'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect } from 'react';
import { useToasts } from '../contexts/toasts';
import { AnimatedNumberWidget } from '../components/dashboard/AnimatedNumber';
import { DashboardStatistics } from '../models/generics';
import { ApplicationsStatusWidget, CreatedApplicationsWidget, UserApplicationsWidget } from '../components/dashboard/Widgets';
import { Dashboard } from '../api/Dashboard';


export default function DashboardPage() {
  const [dashboardStats, setDashboardStats] = useState<DashboardStatistics>();

  const { showToast } = useToasts();

  const initStatistics = useCallback(() => {
    Dashboard.getStatistics()
      .then(
        ({ data }) => setDashboardStats(data),
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('stats-error', message, `Dashboard Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }, [showToast]);

  useEffect(() => initStatistics(), [initStatistics]);

  return (
    <div className="p-3">
      <div className="p-3 pt-0 mb-3 d-flex justify-content-center">
        <Logo greyScale={true} width={200} />
      </div>

      <Row className="justify-content-center">
        <Col sm={6} md={4} className="mb-2 mb-md-0">
          { /* eslint-disable-next-line */}
          <a className="dashboard-link mx-auto me-md-0" href="https://home.alidalab.it" target="_blank" rel="noopener noreferer">
            <FontAwesomeIcon icon={solid('home')} />
            <span className="ms-3">Official Website</span>
          </a>
        </Col>
        <Col sm={6} md={4}>
          { /* eslint-disable-next-line */}
          <a className="dashboard-link mx-auto ms-md-0" href="https://docs.alidalab.it" target="_blank" rel="noopener noreferer">
            <FontAwesomeIcon icon={solid('book')} />
            <span className="ms-3">Official Documentation</span>
          </a>
        </Col>
      </Row>

      <Row className="justify-content-center mt-3">
        <Col md={4} lg={3} className="mb-2">
          <AnimatedNumberWidget title="Available Services" icon={solid('cubes')} number={dashboardStats?.createdServices} type="services" />
        </Col>
        <Col md={4} lg={3} className="mb-2">
          <AnimatedNumberWidget title="Available Datasets" icon={solid('database')} number={dashboardStats?.createdDatasets} type="datasets" />
        </Col>
        <Col md={4} lg={3}>
          <AnimatedNumberWidget title="Available Models" icon={solid('graduation-cap')} number={dashboardStats?.createdModels} type="models" />
        </Col>
      </Row>

      <Row className="mt-2">
        <Col lg={4} md={6} className="mb-2">
          <UserApplicationsWidget statistics={dashboardStats} />
        </Col>

        <Col lg={4} md={6} className="mb-2">
          <CreatedApplicationsWidget appsByDate={dashboardStats?.bdaApplicationsByMonth} />
        </Col>

        <Col lg={4} md={6} className="mb-2">
          <ApplicationsStatusWidget statistics={dashboardStats} />
        </Col>
      </Row>
    </div>
  )
}
